import { connect } from 'react-redux';
import { getOr, keyBy, mapValues } from 'lodash/fp';
import {
  getIsFetchedClientColumns,
  getClientColumnsByName
} from '../../redux/selectors/client';
import {
  getIsFetchedVisitColumns,
  getVisitColumnsByName
} from '../../redux/selectors/visit/columns';
import {
  VISIT_GROUP,
  CLIENT_GROUP,
  VISIT_TRACK_GROUP,
  VisitTrackColumns
} from './constants';
import formatResult from './helpers/formatResult';
import composeReadableSearchQuery from './helpers/composeReadableSearchQuery';
import { visitTrackingMethodByName as visitTrackingMethodColumnByName } from './helpers/customColumns';
import {
  getIsFetchedOutreachAggregateOptions as isFetchedOptions,
  getOutreachAggregateLocationOptions,
  getSortedOutreachAggregateTrackingMethodOptions as getTrackingMethodOptions
} from '../../redux/selectors/report/outreach-aggregate/options';
import OutreachAggregateView from '../../components/OutreachAggregateView';

const toColumnsByType = (
  clientColumnsByName,
  visitColumnsByName,
  visitTrackColumnsByName
) => ({
  [CLIENT_GROUP]: clientColumnsByName,
  [VISIT_GROUP]: visitColumnsByName,
  [VISIT_TRACK_GROUP]: visitTrackColumnsByName
});

const appendVisitTrackingMethodColumn = columnsByName => ({
  ...columnsByName,
  ...visitTrackingMethodColumnByName
});

function mapStateToProps(state, { result, downloadRequest }) {
  const clientColumnsByName = getClientColumnsByName(state);
  const visitColumnsByName = getVisitColumnsByName(state);
  const locationOptions = getOutreachAggregateLocationOptions(state);
  const trackingMethodOptions = getTrackingMethodOptions(state);
  const isOptionsLoaded = isFetchedOptions(state);
  const isVisitColumnsLoaded = getIsFetchedVisitColumns(state);
  const isClientColumnsLoaded = getIsFetchedClientColumns(state);
  const isDataLoaded =
    isOptionsLoaded && isVisitColumnsLoaded && isClientColumnsLoaded;

  const searchQuery = getOr({}, 'meta.query', downloadRequest);
  const visitTrackColumnsByName = appendVisitTrackingMethodColumn(
    keyBy('name', VisitTrackColumns)
  );

  const columnsByType = toColumnsByType(
    clientColumnsByName,
    visitColumnsByName,
    visitTrackColumnsByName
  );

  const readableSearchQuery = isDataLoaded
    ? composeReadableSearchQuery(
        searchQuery,
        locationOptions,
        trackingMethodOptions,
        columnsByType
      )
    : {};

  const columnLabels = isDataLoaded
    ? {
        ...mapValues('label', visitColumnsByName),
        ...mapValues('label', clientColumnsByName),
        ...mapValues('label', visitTrackColumnsByName)
      }
    : {};

  return {
    isDataLoaded,
    result: formatResult(result),
    downloadRequest,
    searchQuery,
    readableSearchQuery,
    columnLabels
  };
}

export default connect(
  mapStateToProps,
  null
)(OutreachAggregateView);
